import request from "@utils/request";

export function getUser(id) {
  return request({
    url: "/user/api",
    method: "get",
    params: { id: id }
  });
}

export function changePassword(data) {
  console.log(data.id);
  return request({
    url: "/user/api",
    method: "put",
    data: { id: data.id, newPassword: data.newPassword, oldPassword: data.oldPassword }
  });
}

// 查看是否拥有查看急救车实况的权限  | 针对护士而言
export function getPermission(data) {
  return request({
    url: "/user/api",
    method: "post",
    data
  });
}

// 获得数据库所有的用户信息
export function dealAllUser(form) {
  const { howPage, page, type, name } = form;
  return request({
    url: "/srs/user-new",
    method: "get",
    params: {
      pagesize: howPage, page, type, name
    }
  });
}

// 获得数据库用户 个数
// export function getUserNum() {
//   return request({
//     url: "/user/api",
//     method: "get",
//   });
// }

// 添加用户
// export function addUser(data) {
//   return request({
//     url: "/user/api",
//     method: "post",
//     data
//   });
// }
/**
 * 新增用户或者修改用户
 * @param {Object} data - 提交的表单
 * @param {string} method - 提交的方式, 修改和新建不一样
 * */
export function addNewUser(data, method) {
  return request({
    url: "/srs/user-new",
    method,
    headers: { "Content-Type": "application/json" },
    transformRequest: null,
    data
  });
}

// 查询用户
// export function checkUser(checkRealName) {
//   return request({
//     url: "/user/api",
//     method: "get",
//     params: { checkRealName }
//   });
// }

// 删除用户
export function deleteUser(data) {
  return request({
    url: "/srs/user-new",
    method: "put",
    data
  });
}

// 修改用户
export function changeUser(data) {
  return request({
    url: "/user/api",
    method: "post",
    data
  });
}

// 下单登陆验证权限
export function checkUserForOrder(data) {
  return request({
    url: "/user/api",
    method: "post",
    data
  });
}

// 通话协助 邀请别的用户
export function inviteAssistantUser(data) {
  return request({
    headers: { "Content-Type": "application/json" },
    transformRequest: null,
    url: "/new/version/assist/message",
    method: "post",
    data
  });
}

// 通话协助 同意邀请协助
export function finishInviteAssistant(data) {
  return request({
    headers: { "Content-Type": "application/json" },
    transformRequest: null,
    url: "/new/version/assist/message",
    method: "PUT",
    data
  });
}

// 获取排班需要的数据
export function getDepartUser() {
  return request({
    url: "/srs/depart-user",
    method: "get",
  });
}

/*
* 获取一周的排版记录
* */
export function getWeekData(data) {
  return request({
    url: "/srs/scheduling",
    method: "get",
    params: data
  });
}

/*
* 获取一周的排版记录
* */
export function saveWeekPlan(data) {
  return request({
    url: "/srs/scheduling",
    //  可能会有错
    transformRequest: null,
    method: "post",
    headers: { "Content-Type": "application/json" },
    data
  });
}

// 获取所有的用户数据，并且不分页
export function getAllUsers() {
  return request({
    url: "/new/version/all/user/data",
    method: "get",
  });
}
